<template>
  <router-view v-if="point" :project.sync="project" :module.sync="module" :point.sync="point" />
  <span v-else />
</template>

<script>

import $api from '@/libs/OAuth2/services/api';

export default {
  name: 'module-frame',
  props: {
    project: {
      type: Object,
      required: true,
    },
    module: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      point: null,
    };
  },
  watch: {
    point: {
      handler (newVal) {
        this.$root.point = newVal;
      },
      immediate: true,
    },
  },
  destroyed () {
    this.$root.point = null;
  },
  beforeRouteEnter (to, from, next) {
    const id = to.params?.pointId;
    if (!id) {
      return next(from);
    }

    $api.fetchPoint(id)
      .then(res => res.data)
      .then(data => {
        if (!data) {
          return next(from);
        }

        next(vm => {
          vm.point = data;
        });
      })
      .catch(() => next(from))
    ;
  },
};

</script>
